import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

//import TAMMAX from '../../../business-rules/TamMax/TamMax'

import AuthService from '../../../business-api/AuthService'

import ClienteService from '../../../business-api/ClienteService'

import {
    nomeCurtoCliente,
} from '../../../business-rules/String/nomeCurto'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    CardGridEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridContainerS0,
    GridItem1,
    GridItem1xs2,
    GridItem2,
    GridItem2xs4,
    GridItem2sm3xs6,
    GridItem3xs4,
    GridItem3xs6,
    GridItem3xs12,
    GridItem6,
    GridItem10,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import { 
//    TextValidatorTextDestaque,
    TextValidatorValor,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldNumberSelectDestaque,
} from '../../../business-components/TextField/TextFieldSelect'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
    KeyboardDateTimePickerPadrao,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    ButtonSalvar,
    ButtonCompartilhar,
    ButtonIntegracao,
    ButtonVisualizarPDFInstitucional,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
    CustomizedDialogsViewPDF,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    CustomizedDialogsVideo,
} from '../../../business-components/Video/Video'

import {
    IconButtonVersao,
    //IconButtonVersaoDisabled,
    IconButtonClear,
} from '../../../business-components/IconButton/IconButton'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

//import formList from '../../../business-rules/List/formList'

import {
    redirecionarIntegracaoClienteArquivoList,
} from '../ClienteListService'

import {
    exibeCompartilhamentoUsuario
} from '../compartilhamento-form/CompartilhamentoService'

import {
    comparaCliente,
} from './ClienteService'

import {
    incluirFunisEtapas,
} from './ClienteServiceCliente'

import {
    WhatsAppUsuario
} from '../compartilhamento-form/CompartilhamentoComp'

import {
    getArquivoByGrupoArquivoTipoArquivoConteudo,
} from '../../arquivo/ArquivoService'

import {
    modoApresentacao,
} from '../estudo-form/EstudoService'

import CompartilhamentoForm from '../compartilhamento-form/CompartilhamentoForm'

import VersaoForm from '../versao-form/VersaoForm'



const ClienteFormCliente = ({ variaveisGlobais, values, valuesAnt, handleChange, handleSubmit, handleSubmitBotaoSalvar, setFieldValue,
    vars, linhaFormList, setTabIndexClientePrimeiraReuniaoAprofundamento, saving, tabClienteFormList, jsonIntegracao }) => {
    
    //const linhaFormList = pesquisaList(formList, values.idFormList)

    const [pdf, setPdf] = useState(null)

    useSingleton(async() => {

        if (vars.idConfiguracao) {

            const arquivoArquivoAcessoDTO =
                await getArquivoByGrupoArquivoTipoArquivoConteudo(variaveisGlobais,
                    ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais),
                        HARDCODE.idGrupoArquivoConfiguracao, HARDCODE.idTipoArquivoInstitucional, vars.idConfiguracao, null, null)

            setPdf(arquivoArquivoAcessoDTO.conteudo)
        }
    })

    let linhaFunilEtapas = {}

    if (values.etapa) {

        linhaFunilEtapas = pesquisaList(vars.jsonConfiguracao.funilEtapas, values.etapa)

        if (
                values.funisEtapas.length === 0 || 
                !values.etapaAnt ||
                values.etapa !== values.etapaAnt
            ) 
        {

            values.dataHoraPrevistaFunilEtapa = null
            values.dataRealizacaoFunilEtapa = null

            incluirFunisEtapas(values)
        }

        values.funisEtapas[0].funil = values.funil
        values.funisEtapas[0].etapa = values.etapa
        values.funisEtapas[0].dataHoraPrevistaFunilEtapa = values.dataHoraPrevistaFunilEtapa
        values.funisEtapas[0].dataRealizacaoFunilEtapa = values.dataRealizacaoFunilEtapa

        if (linhaFunilEtapas.exibirPotencialNegocios) {

            values.potencialNegociosSomar = values.potencialNegocios

        } else {

            values.potencialNegociosSomar = '0'
        }
    }

    const compartilhamentoUsuario =
        values.compartilhamentoUsuario && values.compartilhamentoUsuario.length > 0
            ?
                values.compartilhamentoUsuario.filter(linha => linha.id !== AuthService.obterUsuarioLogado(variaveisGlobais))
            :
                values.compartilhamentoUsuario

    if (values.compartilhamentoUsuario && values.compartilhamentoUsuario.length > 0) {

        if (AuthService.obterUsuarioLogado(variaveisGlobais) !== ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais)) {

            compartilhamentoUsuario.push(
                {id: ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais)}
            )
        }
    }
    
    const idFuncionalidade = () => {

        return (
            tabClienteFormList === LABEL.tabClienteFormListCadastro
                ?
                    '505'
                :
                    tabClienteFormList === LABEL.tabClienteFormListDadosBasicos
                        ?
                            '510'
                        :
                            tabClienteFormList === LABEL.tabClienteFormListSimulacaoFinanceira
                                ?
                                    '520'
                                :
                                    tabClienteFormList === LABEL.tabClienteFormListEstudo
                                        ?
                                            values.tabEstudoFormList === LABEL.acumulacao ||
                                            values.tabEstudoFormList === LABEL.conferenciaDados
                                                ?
                                                    '574'
                                                :
                                                    values.tabEstudoFormList === LABEL.previdenciaPrivada
                                                        ?
                                                            '576'
                                                        :
                                                            values.tabEstudoFormList === LABEL.relatorio
                                                                ?
                                                                    '578'
                                                                :
                                                                    '500'
                                        :
                                            '500'
        )
    }



    return (
        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <CardGridEntradaDados>
                <CardGridDivBodyEntradaDados>
                    {(!jsonIntegracao ||
                    (!jsonIntegracao.integracaoInclusaoSiteInstitucional &&
                    !jsonIntegracao.integracaoInclusaoSiteInstitucional2 &&
                    !jsonIntegracao.integracaoInclusaoCaptacaoLeads)) && (
                        <GridContainer
                            className='mt-1 mb-2'
                        >
                            {AuthService.obterAcessoCliente(variaveisGlobais)
                                ?
                                    <GridItem12>
                                        <h2
                                            className='mt-3 mb-2'
                                        >
                                            {values.nomeCliente}
                                        </h2>
                                    </GridItem12>
                                :
                                    <>
                                        <GridItem3xs12>
                                            {/*
                                            <TextValidatorTextDestaque
                                                name="nomeCliente"
                                                label={LABEL.nomeCliente}
                                                value={values.nomeCliente || ''}
                                                onChange={handleChange}
                                                tamMax={TAMMAX.nome}
                                                //disabled={true}
                                            />
                                            */}
                                            <h2
                                                className='mt-3 mb-2'
                                            >
                                                {nomeCurtoCliente(values)}
                                            </h2>
                                        </GridItem3xs12>

                                        <GridItem3xs4>
                                            {linhaFormList.radioGroupFormList &&
                                            //vars.perfil !== HARDCODE.perfilAssessor &&
                                            //linhaFormList.exibirCompleto === 'S' &&
                                            vars.linhaTipoLicenca.exibirSimulacaoFinanceira === "S" &&
                                            vars.linhaTipoLicenca.exibirCompleto === 'S' && (
                                                <linhaFormList.radioGroupFormList
                                                    name="formListRadioGroup"
                                                    value={values.formListRadioGroup || ''}
                                                    onChange={(e) => {
                                                        setTabIndexClientePrimeiraReuniaoAprofundamento(e.target.value,
                                                            values.tabIndexClientePrimeiraReuniao, 
                                                                values.tabIndexClienteAprofundamento, values.idFormList, vars.linhaTipoLicenca,
                                                                    vars.usuarioClienteSelecionadoAtivo, vars.jsonUsuario,
                                                                        values.jsonAcessoCliente
                                                        )
                                                        handleChange(e)
                                                    }}
                                                />
                                            )}
                                        </GridItem3xs4>

                                        <GridItem2xs4
                                            className="mt-2"
                                        >
                                            <GridContainer>
                                                <GridItem6>
                                                    {vars.idConfiguracao &&
                                                    (!vars.linhaTipoLicenca || vars.linhaTipoLicenca.exibirSomentePrevidenciaPrivada === 'N') &&
                                                    values.id && values.nomeCliente && (
                                                        <ButtonIntegracao
                                                            cor={2}
                                                            onClick={() =>
                                                                redirecionarIntegracaoClienteArquivoList(variaveisGlobais,
                                                                    AuthService.obterUsuarioSelecionado(variaveisGlobais)[0].id,
                                                                        vars.idConfiguracao, values.id, values.nomeCliente, values.ultimaVersao, 
                                                                            JSON.stringify(values.jsonComparacaoEstudos), values.versao)
                                                            }
                                                            disabled={!comparaCliente(values, valuesAnt) || saving}
                                                        />
                                                    )}
                                                </GridItem6>

                                                <GridItem6
                                                    className='mt--3'
                                                >
                                                    {pdf && (
                                                        <CustomizedDialogsViewPDF
                                                            //className='p-3'
                                                            maxWidth='xl'
                                                            fullScreen={true}
                                                            zoom={0.8}
                                                            popupTitle={LABEL.institucional}
                                                            PopupButton={ButtonVisualizarPDFInstitucional}
                                                            pdfFile={pdf}
                                                        />
                                                    )}
                                                </GridItem6>
                                            </GridContainer>
                                        </GridItem2xs4>

                                        <GridItem1xs2
                                            className="mt-2"
                                        >
                                            {
                                                vars.jsonConfiguracao.habilitaCompartilhamentoClientes/* && 
                                                vars.jsonConfiguracao.compartilhamentoPerfilUsuario*/
                                                    ?
                                                        values.ultimaVersao === values.versao && (
                                                            <GridContainerS0>
                                                                <GridItem10>
                                                                    <CustomizedDialogsPopup
                                                                        maxWidth='sm'
                                                                        popupTitle={LABEL.buttonCompartilhar}
                                                                        PopupButton={ButtonCompartilhar}
                                                                        popupComponent={
                                                                            <CompartilhamentoForm
                                                                                variaveisGlobais={variaveisGlobais}
                                                                                values={values}
                                                                                handleChange={handleChange}
                                                                                equipeList={vars.equipeList}
                                                                                perfil={vars.perfil}
                                                                                jsonConfiguracao={vars.jsonConfiguracao}
                                                                            />
                                                                        }
                                                                    />
                                                                </GridItem10>
                                                                <GridItem2>
                                                                    {
                                                                        values.compartilhamentoUsuario && 
                                                                        values.compartilhamentoUsuario.length > 0
                                                                            ?
                                                                                "(" + values.compartilhamentoUsuario.length + ")"
                                                                            :
                                                                                ""
                                                                    }
                                                                </GridItem2>
                                                            </GridContainerS0>
                                                        )
                                                    :
                                                        ''
                                            }
                                        </GridItem1xs2>

                                        <GridItem1xs2>
                                            <GridContainerS0>
                                                <GridItem10>
                                                    <CustomizedDialogsPopup
                                                        maxWidth='md'
                                                        popupTitle={LABEL.iconButtonVersao}
                                                        PopupButton={IconButtonVersao}
                                                        //    !comparaCliente(values, valuesAnt) || saving
                                                        //        ?
                                                        //            IconButtonVersaoDisabled
                                                        //        :
                                                        //            IconButtonVersao
                                                        //}
                                                        popupComponent={
                                                            <VersaoForm
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                handleChange={handleChange}
                                                            />
                                                        }
                                                        disabled={!comparaCliente(values, valuesAnt) || saving}
                                                        open={() => modoApresentacao(setFieldValue, true)}
                                                        afterClose={() => modoApresentacao(setFieldValue, false)}
                                                    />
                                                </GridItem10>

                                                <GridItem2
                                                    className={'mt-4' + (values.ultimaVersao !== values.versao ? ' text-error' : '')}
                                                >
                                                    {'v.' + values.versao}
                                                </GridItem2>
                                            </GridContainerS0>
                                        </GridItem1xs2>

                                        <GridItem1xs2
                                            className='mt-1'
                                        >
                                            <CustomizedDialogsVideo
                                                idFuncionalidade={idFuncionalidade()}
                                            />
                                        </GridItem1xs2>
                                    </>
                            }
                        </GridContainer>
                    )}

                    {(!jsonIntegracao ||
                    (jsonIntegracao &&
                    !jsonIntegracao.integracaoInclusaoSiteInstitucional &&
                    !jsonIntegracao.integracaoInclusaoSiteInstitucional2 &&
                    !jsonIntegracao.integracaoInclusaoCaptacaoLeads)) && (
                        <div
                            style={{
                                position: 'fixed',
                                right: '40px',
                                top: AuthService.obterAcessoCliente(variaveisGlobais) ? '95px' : '120px',
                                zIndex: 99,
                                transition: 'all 0.15s ease',
                            }}
                        >
                            <GridItem2xs4>
                                <ButtonSalvar
                                    align="right"
                                    onClick={() => {handleSubmitBotaoSalvar(values)}}
                                    disabled={comparaCliente(values, valuesAnt) || saving}
                                />
                            </GridItem2xs4>
                        </div>
                    )}

                    <GridContainer>
                        {!AuthService.obterAcessoCliente(variaveisGlobais) &&
                        tabClienteFormList !== LABEL.tabClienteFormListEstudo &&
                        tabClienteFormList !== LABEL.tabClienteFormListRelatorio && (
                            <>
                                {vars.jsonConfiguracao && vars.jsonConfiguracao.funis && vars.jsonConfiguracao.funis.length > 0
                                    ?
                                        <GridItem3xs6>
                                            <GridContainerS0>
                                                <GridItem11>
                                                    <TextFieldNumberSelectDestaque
                                                        name="funil"
                                                        label={LABEL.funil}
                                                        value={values.funil || ''}
                                                        onChange={(e) => {
                                                            values.etapa = null
                                                            handleChange(e)
                                                        }}
                                                        list={
                                                            vars.jsonConfiguracao.funis
                                                                .filter(funil => funil.id === values.funil || funil.ativo !== 'N')
                                                        }
                                                        disabled={values.ultimaVersao !== values.versao}
                                                    />
                                                </GridItem11>
                                                <GridItem1>
                                                    {values.ultimaVersao === values.versao && (
                                                        <IconButtonClear
                                                            className='mt-3'
                                                            onClick={() => {
                                                                values.funil = null
                                                                values.etapa = null
                                                                values.dataHoraPrevistaFunilEtapa = null
                                                                values.dataRealizacaoFunilEtapa = null
                                                                incluirFunisEtapas(values)
                                                                setFieldValue(
                                                                    'funil',
                                                                    null,
                                                                )
                                                            }}
                                                        />
                                                    )}
                                                </GridItem1>
                                            </GridContainerS0>
                                        </GridItem3xs6>
                                    :
                                        ''
                                }

                                {
                                    vars.jsonConfiguracao &&
                                    vars.jsonConfiguracao.funis &&
                                    vars.jsonConfiguracao.funis.length > 0 &&
                                    values.funil
                                        ?
                                            <GridItem3xs6>
                                                <TextFieldNumberSelectDestaque
                                                    name="etapa"
                                                    label={LABEL.etapa}
                                                    value={values.etapa || ''}
                                                    onChange={handleChange}
                                                    list={
                                                        vars.jsonConfiguracao.funilEtapas
                                                            .filter(funilEtapa => funilEtapa.funil === values.funil &&
                                                                (
                                                                    funilEtapa.id === values.etapa ||
                                                                    funilEtapa.ativo !== 'N'
                                                                ))
                                                    }
                                                    disabled={values.ultimaVersao !== values.versao}
                                                />
                                            </GridItem3xs6>
                                        :
                                            ''
                                }
                                    
                                {
                                    vars.jsonConfiguracao &&
                                    vars.jsonConfiguracao.funis &&
                                    vars.jsonConfiguracao.funis.length > 0 &&
                                    values.etapa &&
                                    linhaFunilEtapas.informarDataHoraPrevista
                                        ?
                                            <GridItem2sm3xs6>
                                                <MuiPickersUtilsProviderPadrao>
                                                    <KeyboardDateTimePickerPadrao
                                                        name="dataHoraPrevistaFunilEtapa"
                                                        label={LABEL.dataHoraPrevista}
                                                        value={values.dataHoraPrevistaFunilEtapa}
                                                        onChange={(date) => {
                                                            setFieldValue(
                                                                'dataHoraPrevistaFunilEtapa',
                                                                date,
                                                            )}
                                                        }
                                                        disabled={values.ultimaVersao !== values.versao}
                                                    />
                                                </MuiPickersUtilsProviderPadrao>
                                            </GridItem2sm3xs6>
                                        :
                                            ''
                                }

                                {
                                    vars.jsonConfiguracao &&
                                    vars.jsonConfiguracao.funis &&
                                    vars.jsonConfiguracao.funis.length > 0 &&
                                    values.etapa &&
                                    linhaFunilEtapas.informarDataRealizacao
                                        ?
                                            <GridItem2sm3xs6>
                                                <MuiPickersUtilsProviderPadrao>
                                                    <KeyboardDatePickerPadrao
                                                        name="dataRealizacaoFunilEtapa"
                                                        label={LABEL.dataRealizacao}
                                                        value={values.dataRealizacaoFunilEtapa}
                                                        onChange={(date) => {
                                                            setFieldValue(
                                                                'dataRealizacaoFunilEtapa',
                                                                date,
                                                            )}
                                                        }
                                                        disabled={values.ultimaVersao !== values.versao}
                                                    />
                                                </MuiPickersUtilsProviderPadrao>
                                            </GridItem2sm3xs6>
                                        :
                                            ''
                                }

                                {
                                    vars.jsonConfiguracao &&
                                    vars.jsonConfiguracao.funis &&
                                    vars.jsonConfiguracao.funis.length > 0 &&
                                    values.etapa &&
                                    linhaFunilEtapas.exibirPotencialNegocios &&
                                    !values.modoInteracaoCliente
                                        ?
                                            <GridItem2sm3xs6>
                                                <TextValidatorValor
                                                    name="potencialNegocios"
                                                    label={LABEL.potencialNegocios}
                                                    value={values.potencialNegocios || ''}
                                                    onChange={handleChange}
                                                    disabled={values.ultimaVersao !== values.versao}
                                                />
                                            </GridItem2sm3xs6>
                                        :
                                            ''
                                }
                            </>
                        )}
                    </GridContainer>

                    {values.compartilhamentoUsuario &&
                    values.compartilhamentoUsuario.length > 0 &&
                    !AuthService.obterAcessoCliente(variaveisGlobais) && (
                        <GridContainer
                            className='ml-1 mb-1'
                        >
                            {compartilhamentoUsuario?.map( (item, ind) => {
                                return item.id ? (
                                    <GridContainerS0
                                        key={ind}
                                    >
                                        <GridItem12
                                        >
                                            <span
                                                dangerouslySetInnerHTML={
                                                    { __html: exibeCompartilhamentoUsuario(item.id, vars.equipeList, vars.jsonConfiguracao)}
                                                }
                                            />

                                            <WhatsAppUsuario
                                                item={item}
                                                equipeList={vars.equipeList}
                                            />
                                        </GridItem12>
                                    </GridContainerS0>
                                )
                                :
                                (
                                    ''
                                )
                            })}
                        </GridContainer>
                    )}
                </CardGridDivBodyEntradaDados>
            </CardGridEntradaDados>
        </ValidatorFormPadrao>
    )
}

export default ClienteFormCliente